(() => {
  if (window.westyProductColoursReady) return;
  window.westyProductColoursReady = true;

  const choiceSelector = '.wh-product-colours__choice';
  const previewKeys = ['preview_theme_id', '_fd', 'pb'];
  let pending;
  let sequence = 0;
  let renderedPath = window.location.pathname;

  function productUrl(href) {
    const url = new URL(href, window.location.origin);
    const current = new URL(window.location.href);
    previewKeys.forEach((key) => {
      if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
    });
    const theme = window.Shopify?.theme;
    if (!url.searchParams.has('preview_theme_id') && theme?.id && theme.role && theme.role !== 'main') {
      url.searchParams.set('preview_theme_id', theme.id);
    }
    return url;
  }

  function preserveSize(url, link, main) {
    try {
      const selected = Array.from(main.querySelectorAll('variant-picker select, variant-picker input[type="radio"]:checked'))
        .map((input) => input.value);
      const variants = JSON.parse(link.dataset.variants || '[]');
      const match = variants.find((variant) => selected.length && variant.options.length === selected.length &&
        variant.options.every((option, index) => option === selected[index]));
      if (match) url.searchParams.set('variant', match.id);
    } catch (error) {
      console.warn('[Westy colour] Could not preserve size', error);
    }
  }

  function setLoading(main, loading) {
    main.classList.toggle('wh-product-changing', loading);
    main.toggleAttribute('aria-busy', loading);
    main.querySelectorAll('product-form-component, variant-picker, sticky-add-to-cart').forEach((element) => {
      element.inert = loading;
    });
  }

  function ensureScripts(main) {
    main.querySelectorAll('script[src]').forEach((script) => {
      const exists = Array.from(document.scripts).some((existing) => existing !== script && existing.src === script.src);
      if (exists) return;
      const active = document.createElement('script');
      Array.from(script.attributes).forEach((attribute) => active.setAttribute(attribute.name, attribute.value));
      document.head.append(active);
    });
  }

  function updateMetadata(html) {
    if (html.title) document.title = html.title;
    ['link[rel="canonical"]', 'meta[name="description"]', 'meta[property="og:title"]',
      'meta[property="og:description"]', 'meta[property="og:url"]', 'meta[property="og:image"]'].forEach((selector) => {
      const next = html.querySelector(selector);
      const current = document.head.querySelector(selector);
      if (next && current) current.replaceWith(document.importNode(next, true));
    });
  }

  async function switchColour(url, { link, historyMode = 'push', restoreFocus = true } = {}) {
    const main = document.getElementById('MainContent');
    if (!main || url.origin !== window.location.origin) return;
    pending?.abort();
    const controller = new AbortController();
    pending = controller;
    const request = ++sequence;
    const colours = main.querySelector('.wh-product-colours');
    const status = colours?.querySelector('[role="status"]');
    const expectedProductId = link?.dataset.productId;
    const scrollPosition = { x: window.scrollX, y: window.scrollY };
    const timeout = setTimeout(() => controller.abort(), 20000);
    setLoading(main, true);
    main.querySelectorAll(`${choiceSelector}[aria-busy]`).forEach((choice) => choice.removeAttribute('aria-busy'));
    link?.setAttribute('aria-busy', 'true');
    if (status) {
      status.classList.add('visually-hidden');
      status.textContent = colours.dataset.loadingLabel;
    }

    try {
      const response = await fetch(url.href, { signal: controller.signal, credentials: 'same-origin' });
      if (!response.ok) throw new Error(`Product request failed: ${response.status}`);
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const source = html.getElementById('MainContent');
      const incomingProductId = source?.querySelector('.wh-product-colours')?.dataset.productId;
      if (!source?.querySelector('.product-information') || (expectedProductId && incomingProductId !== expectedProductId)) {
        throw new Error('Product content did not match the chosen colour');
      }
      if (request !== sequence) return;
      const next = document.importNode(source, true);
      main.replaceWith(next);
      ensureScripts(next);
      updateMetadata(html);
      renderedPath = url.pathname;
      if (historyMode === 'push') window.history.pushState({ ...window.history.state, westyColour: true }, '', url.href);
      const selected = next.querySelector(`${choiceSelector}.is-current`);
      if (restoreFocus) selected?.focus({ preventScroll: true });
      window.scrollTo(scrollPosition.x, scrollPosition.y);
      const newColours = next.querySelector('.wh-product-colours');
      const newStatus = newColours?.querySelector('[role="status"]');
      if (newStatus) newStatus.textContent = `${newColours.dataset.loadedLabel}: ${selected?.title || ''}`;
      window.Shopify?.PaymentButton?.init?.();
      next.dispatchEvent(new CustomEvent('westy:product-changed', { bubbles: true, detail: { url: url.href, productId: incomingProductId } }));
    } catch (error) {
      if (request !== sequence) return;
      setLoading(main, false);
      if (status) {
        status.classList.remove('visually-hidden');
        status.textContent = colours.dataset.errorLabel;
      }
      if (historyMode === 'none' && window.location.pathname !== renderedPath) {
        window.history.replaceState(window.history.state, '', productUrl(renderedPath).href);
      }
      console.warn('[Westy colour] Product update failed', error);
    } finally {
      clearTimeout(timeout);
      if (request === sequence) {
        pending = undefined;
        link?.removeAttribute('aria-busy');
        if (main.isConnected) setLoading(main, false);
      }
    }
  }

  document.addEventListener('click', (event) => {
    const link = event.target instanceof Element ? event.target.closest(choiceSelector) : null;
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === '_blank') return;
    const main = link.closest('#MainContent');
    if (!main) return;
    const url = productUrl(link.href);
    if (url.origin !== window.location.origin) return;
    event.preventDefault();
    if (link.classList.contains('is-current') && !pending) return;
    preserveSize(url, link, main);
    switchColour(url, { link });
  });

  window.addEventListener('popstate', () => {
    if (!window.location.pathname.includes('/products/')) return;
    switchColour(productUrl(window.location.href), { historyMode: 'none', restoreFocus: false });
  });
})();
